import React from "react";
import { Card, CardContent, Link, Typography } from "@mui/material";
import { KVCardRow } from "./CardContent";

export default function PlaybookInfoCard({ playbook }) {
  const params = new URLSearchParams(window.location.search);
  const playbookURL = params.get("playbook");

  let name = "";
  let codeURL = "";

  if (playbookURL) {
    name = playbookURL
      .substring(playbookURL.lastIndexOf("/") + 1)
      .replace(".json", "");

    codeURL = playbookURL.replace(".json", ".py");
  }

  return (
    <div
      style={{
        marginTop: 10,
        marginLeft: 10,
        position: "absolute",
        left: 0,
        top: 0,
        minWidth: 300,
        width: 500,
        maxWidth: "25%",
        overflow: "auto",
        zIndex: 1000,
        colorScheme: "dark",
        textAlign: "left",
      }}
    >
      <Card className="playbookInfoCard">
        <CardContent>
          <Typography variant="h6" style={{paddingBottom: 10}}>
            Splunk SOAR Playbook Explorer 
          </Typography>

          <KVCardRow label={"Playbook Name"} value={name}></KVCardRow>

          <KVCardRow
            label={"Description"}
            value={playbook.coa.data.description}
          ></KVCardRow>
          <KVCardRow
            label={"Notes"}
            value={playbook.coa.data.notes}
          ></KVCardRow>
          <KVCardRow
            label={"Playbook Type"}
            value={playbook.coa.playbook_type}
          ></KVCardRow>
          <KVCardRow label={"Category"} value={playbook.category}></KVCardRow>
          <KVCardRow
            label={"Labels"}
            value={playbook.labels.join(", ")}
          ></KVCardRow>
          <KVCardRow
            label={"Tags"}
            value={playbook.labels.join(", ")}
          ></KVCardRow>
 
         <Link variant="body2" href={codeURL} rel="noopener noreferrer" target="_blank">Source Code</Link>
        </CardContent>
      </Card>
    </div>
  );
}
